import { inject, Provider } from '@angular/core';
import { AuthService } from 'zenith/auth';

import { MENU_TOKEN } from '@core/token/menu.token';

import menuConfig from 'src/environments/menu';
import { Role } from 'zenith/core';
import { MenuItem } from 'primeng/api';

type MenuItemWithRole = MenuItem & { role?: Role[]; technical?: string[] };

const filterMenuByRole = (
  menu: MenuItemWithRole[],
  hasAnyRole: (roles: Role[]) => boolean,
  userTechnicalGroups: string[]
): MenuItemWithRole[] => {
  const applyMenu = menu.filter(item => {
    let hasAccess = true;

    if (item.role) {
      hasAccess = hasAccess && hasAnyRole(item.role);
    }

    if (item.technical && item.technical.length > 0) {
      const hasTechAccess = item.technical.some(g => userTechnicalGroups.includes(g));
      hasAccess = hasAccess && hasTechAccess;
    }

    return hasAccess;
  });

  return applyMenu
    .map(item => {
      const clonedItem = { ...item };

      delete clonedItem.role;
      delete clonedItem.technical_groups;

      if (clonedItem.items) {
        clonedItem.items = filterMenuByRole(clonedItem.items as MenuItemWithRole[], hasAnyRole, userTechnicalGroups);
      }

      return clonedItem;
    })
    .filter(item => {
      if (item.items?.length === 0) {
        return false;
      }
      return true;
    });
};

export function provideMenu(): Provider[] {
  return [
    {
      provide: MENU_TOKEN,
      useFactory: () => {
        const authService = inject(AuthService);
        const user = authService.getCurrentUser();

        const menu = structuredClone(menuConfig) as MenuItemWithRole[];

        return filterMenuByRole(menu, authService.hasAnyRole, user?.getTechnical?.() || []);
      },
    },
  ];
}
